import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 201,
  name: 'Created',
  description:
    'The request succeeded and a new resource was created. The server returns this after a successful POST (or sometimes PUT) request that results in a new resource being stored.',
  causes: [
    'A POST request successfully created a new resource, such as a new user account, database record, or uploaded file.',
    'A PUT request created a resource at a specific URI that did not previously exist.',
    'The response typically includes a Location header pointing to the newly created resource, and the body may contain the created resource.',
  ],
  fixes: [
    'No fix needed — 201 means the resource was successfully created. If your client does not handle 201, update it to treat 2xx status codes as success.',
    'If your API returns 200 instead of 201 for creation, update the server to return 201 with a Location header for better REST semantics.',
    'Ensure your client follows the Location header in the response if it needs to access the newly created resource.',
  ],
  monitoringTip:
    'If your API endpoint creates resources and should return 201, Uptrack can validate the expected status code. Any deviation triggers an alert so you catch broken creation flows early.',
}

export const Route = createFileRoute('/_site/http/201')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
